import { render } from "./zsRaceSignInfo.vue?vue&type=template&id=4c5d5250&scoped=true"
import script from "./zsRaceSignInfo.vue?vue&type=script&lang=js"
export * from "./zsRaceSignInfo.vue?vue&type=script&lang=js"

import "./zsRaceSignInfo.vue?vue&type=style&index=0&id=4c5d5250&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5d5250"]])

export default __exports__